module.exports = __webpack_public_path__ + "img/ico-pay-huifudg.0223334d.svg";